var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-box",class:{
        'modal-box--closed': !_vm.isOpen,
        'modal-box--default-width': !_vm.width,
        'modal-box--mobile-width':
          ((_vm.$store.getters['getResolution'] < _vm.fullscreenMinWidth)
          && _vm.enableMobileFullscreen)
          ||
          _vm.enableAlwaysFullscreen
          ,
        'modal-box--pulsing': _vm.isPulsingInProgress,
      }},[_c('div',{staticClass:"overlay"}),_vm._v(" "),_c('div',{staticClass:"modal-container",on:{"click":_vm._processClickOnContainer}},[_c('div',{staticClass:"modal",style:([_vm.styleModalObject]),on:{"click":function($event){$event.stopPropagation();}}},[(!_vm.hideCloseButton)?_c('div',{staticClass:"cross",on:{"click":function($event){_vm.close()}}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8d0663a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal-box.vue
// module id = 113
// module chunks = 0